import React from 'react';

/**
 * Spinner — small inline SVG spinner intended for in-button or in-row
 * use. Unlike the page-level <Loader>, it inherits the parent's text
 * colour (currentColor) and has no minimum height, so it slots into a
 * button without changing layout.
 *
 * Props:
 *   - size: tailwind size class (default 'h-4 w-4')
 *   - className: extra classes (e.g. opacity / margin)
 */
const Spinner = ({ size = 'h-4 w-4', className = '' }) => (
  <svg
    className={`animate-spin ${size} ${className}`}
    viewBox="0 0 24 24"
    fill="none"
    aria-label="Loading"
  >
    <circle
      className="opacity-25"
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeWidth="4"
    />
    <path
      className="opacity-75"
      fill="currentColor"
      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    />
  </svg>
);

export default Spinner;
